import { useState } from "react";
import { getCuisineEmoji } from "@/utils/cuisineEmojiMap";

const getBrandAccentColor = (brandColors) => {
  if (!brandColors || !brandColors.length) return null;
  const accent = brandColors.find(c => c.type === "accent");
  if (accent) return accent.hex;
  const viable = brandColors.find(c => {
    const hex = (c.hex || "").toLowerCase();
    return hex !== "#ffffff" && hex !== "#000000" && hex !== "#fff" && hex !== "#000"
      && hex !== "#111111" && hex !== "#e5e5e5" && hex !== "#1e1e1e"
      && hex !== "#ffffff" && hex !== "#191919" && hex !== "#222222";
  });
  return viable ? viable.hex : null;
};

export const BrandLogo = ({ name, logoUrl, size = "md", brandColor, cuisineTag }) => {
  const [imgError, setImgError] = useState(false);
  const sizeClasses = size === "lg" ? "w-16 h-16" : size === "sm" ? "w-10 h-10" : "w-12 h-12";
  const glowStyle = brandColor ? { boxShadow: `0 0 0 2.5px ${brandColor}30, 0 3px 10px ${brandColor}40` } : {};

  if (imgError || !logoUrl) {
    // Cuisine emoji fallback (warm amber gradient)
    if (cuisineTag) {
      const emoji = getCuisineEmoji(cuisineTag);
      return (
        <div className={`${sizeClasses} rounded-xl bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center flex-shrink-0`} style={glowStyle} data-testid={`brand-logo-cuisine-${name?.replace(/\s+/g, '-')}`}>
          <span className={size === "lg" ? "text-2xl" : size === "sm" ? "text-base" : "text-lg"}>{emoji}</span>
        </div>
      );
    }
    // Letter initial fallback (gradient circle)
    const initial = name?.charAt(0)?.toUpperCase() || "?";
    const colors = [
      "from-sky-400 to-sky-500", "from-purple-400 to-purple-500", "from-green-400 to-green-500",
      "from-orange-400 to-orange-500", "from-pink-400 to-pink-500", "from-indigo-400 to-indigo-500",
      "from-teal-400 to-teal-500", "from-red-400 to-red-500",
    ];
    const colorIndex = name ? name.charCodeAt(0) % colors.length : 0;
    return (
      <div className={`${sizeClasses} rounded-xl bg-gradient-to-br ${colors[colorIndex]} flex items-center justify-center flex-shrink-0`} style={glowStyle} data-testid={`brand-logo-fallback-${name?.replace(/\s+/g, '-')}`}>
        <span className="text-white font-bold text-lg">{initial}</span>
      </div>
    );
  }

  return (
    <div className={`${sizeClasses} rounded-xl bg-gradient-to-br from-slate-50 to-slate-100 border border-slate-200/80 flex-shrink-0 flex items-center justify-center overflow-hidden`} style={glowStyle} data-testid={`brand-logo-${name?.replace(/\s+/g, '-')}`}>
      <img src={logoUrl} alt={name} onError={() => setImgError(true)} className="w-[85%] h-[85%] object-contain" loading="lazy" />
    </div>
  );
};

export { getBrandAccentColor };
